<div *ngIf="showApps" class="downloadAppArea">
  <mat-icon (click)="hideapp()" class="material-icons"> close </mat-icon>
  <div class="logoIcon">
    <img  loading="lazy"  [src]="environmentVariables?.FAV_ICON"    alt="Favorite image" />
  </div>
  <div class="textualDownload">
    <h4>
      {{
        lang == 'en'
          ? environmentVariables?.DOWNLOAD_APP_TITLE_EN
          : environmentVariables?.DOWNLOAD_APP_TITLE_AR
      }}
    </h4>
    {{
      lang == 'en'
        ? environmentVariables?.DOWNLOAD_APP_TEXT_EN
        : environmentVariables?.DOWNLOAD_APP_TEXT_AR
    }}
  </div>
  <div class="downloadControls">
    <a
      class="mat-raised-button mat-primary"
      href="{{
        iosDev
          ? environmentVariables?.STORE_APPLE_URL
          : environmentVariables?.STORE_ANDROID_URL
      }}"
      target="_blank"
      >{{ 'download' | translate }}</a
    >
  </div>
</div>
